import { render, staticRenderFns } from "./RectangleObjectLocators.vue?vue&type=template&id=1bdea78f&scoped=true&"
import script from "./RectangleObjectLocators.vue?vue&type=script&lang=ts&"
export * from "./RectangleObjectLocators.vue?vue&type=script&lang=ts&"
import style0 from "./RectangleObjectLocators.vue?vue&type=style&index=0&id=1bdea78f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdea78f",
  null
  
)

export default component.exports